import { BranchStatus } from "../constants/branch-status";

export function isAlias(value: string) {
  return /^[a-zA-Z0-9.]{6,20}$/.test(value);
}

export function isCBU(value: string) {
  return /^\d{22}$/.test(value);
}

export function isBranchReadyForCloverCbu(status: unknown): boolean {
  const n = Number(status);
  return n === BranchStatus.PENDING || n === BranchStatus.APPROVED;
}

export function sanitizeArgBranchNameInput(value: string): string {
  // Solo permitir letras, números, espacios y puntos
  let sanitized = value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ0-9\s.]/g, "");
  // No permitir más de 1 espacio consecutivo
  sanitized = sanitized.replace(/\s+/g, " ");
  return sanitized;
}


export const isValidImageFile = (file: File): boolean => {
  if (!file) return false;

  const validImageTypes = [
    'image/jpeg',
    'image/jpg', 
    'image/png',
    'image/gif',
    'image/webp',
    'image/bmp',
    'image/tiff'
  ];

  if (!validImageTypes.includes(file.type)) {
    return false;
  }

  const fileName = file.name.toLowerCase();
  const validExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.tiff'];
  const hasValidExtension = validExtensions.some(ext => fileName.endsWith(ext));

  if (!hasValidExtension) {
    return false;
  }

  return true;
};
